import { ButtonPill } from "@/base";
import { css, useTheme } from "@emotion/react";
import useBreakpoints from "@util/breakpoints";
import useWindowResized from "@/helpers/useWindowResized";
import { useEffect, useRef } from "react";

const CarouselNav = ({ slides, setActiveCarousel, activeCarousel }) => {
    const theme = useTheme();

    const rowRef = useRef();
    const spacerRef = useRef();
    const pillsRef = useRef([]);

    useWindowResized(() => {
        let display = rowRef.current.scrollWidth > rowRef.current.clientWidth;
        spacerRef.current.style.display = display ? "block" : "none";
    });

    const rowFlex = useBreakpoints([theme.breakpoint.md])({
        order: ["2", "3"],
    });

    let rowStyles = css(`
                
            .buttonsRow{
                overflow-x: scroll;
                -ms-overflow-style: none;
                -webkit-overflow-scrolling: touch;
                scrollbar-width: none;
                &::-webkit-scrollbar {
                    display: none;
                }
            }
            
            .spacer, .showMore {
                display: block;
                min-width: 100px;
                height: 100%;
            }
            
            .showMore {
                position: absolute;
                text-align: right;
                top: -1px;
                right: 0;
                height: calc(100% + 2px);                
                background: linear-gradient(to right, rgba(255,255,255,0) 0, rgba(255,255,255,1) 40%);
                border: none;
                pointer-events: all;
                
            }
            .showMoreLeft {
                position: absolute;
                text-align: left;
                top: -1px;
                left: 0;
                height: calc(100% + 2px);                
                background: linear-gradient(to right, rgba(255,255,255,0) 0, rgba(255,255,255,1) 40%);
                border: none;
                pointer-events: all;
                
            }
            
            svg {
                    position: relative;
                    height: calc(100% - 2px);
                    top: 1px;
                    right: 0px;
                }
        
        `);

    const fetchTitles = () => {
        let buttonRow = slides.map((slide, slideIndex) => {
            let parentTitle = slide.value.elements.find(
                (el) => el.render_name === "title"
            );
            if (!parentTitle) return;
            return (
                <span className="pill_wrap" key={slide.id} ref={el => { pillsRef.current[slideIndex] = el; }}>
                    <ButtonPill
                        onClick={() => setActiveCarousel(slideIndex)}
                        buttonTheme={"grey-rev"}
                        className={`text-nowrap ${slideIndex === activeCarousel ? "active" : ""
                            }`}
                    >
                        {parentTitle.value}
                    </ButtonPill>
                </span>
            );
        });

        return (
            <div css={[rowStyles, rowFlex]} className={`buttonsWrapper posRelative mt-4 maxW-100`} >
                <div ref={rowRef} className={`buttonsRow container flex-nowrap d-flex flex-row maxW-100`} >
                    {buttonRow}
                    <span ref={spacerRef} className={"spacer"}>
                        &nbsp;
                    </span>
                </div>
            </div>
        );
    };


    useEffect(() => {
        // rowRef.current.scrollLeft = itemOffset;
        const wrapWidth = rowRef.current.offsetWidth;
        const itemWidth = pillsRef.current[activeCarousel].offsetWidth;
        const itemOffset = pillsRef.current[activeCarousel].offsetLeft - (wrapWidth/2) + (itemWidth/2);
        rowRef.current.scrollTo({left: itemOffset, behavior:"smooth"});
        // console.log(rowRef);
    }, [activeCarousel])

    return fetchTitles();
};

export default CarouselNav;
